<template>
  <div class="market-CBR-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch">
       <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
    </Search>
    <div class="fun-btn-box">
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #couponName="{ row }">{{ row.couponName }}</template>
      <template #totalAmount="{ row }">{{ row.totalAmount }}</template>
      <template #phone="{ row, scope }">
        <span :key="tableKey">{{ row.phone_show || row.phone }}</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #paymentOrderId="{ row }">{{ row.paymentOrderId }}</template>
      <template #payTime="{ row }">{{ row.payTime ? $moment(row.payTime).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #finishTime="{ row }">{{ row.finishTime ? $moment(row.finishTime).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #sourceMallName="{ row }">{{ row.sourceMallName? row.sourceMallName : '---' }}</template>
      <template #status="{ row }">{{ row.status }}</template>
      <template #code="{ row }">{{ row.code ? row.code : '---' }}</template>
      <template #source="{ row }">{{ row.source }}</template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import aes from '@/common/aes.js'
import { downFile } from "@/utils";
import { api_getCouponBuyRecordList, api_postCouponBuyRecordListExport,api_postCouponBuyRecordListExportV2} from '@/api/market'
import { api_getUserPhone, api_getConfig } from '@/api/common'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "mcheckIndex",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    const startDate = this.$moment().subtract(30, 'days').valueOf() //默认开始时间
    const endDate = this.$moment().subtract(0, 'days').valueOf() //默认结束时间
    return {
      renderData: [
        {
          label: "支付时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "time",
          valueFormat: 'timestamp',
        },
        {
          label: "优惠券名称",
          placeholder: "请选择优惠券名称",
          type: "input",
          key: "couponName",
        },
        {
          label: "会员手机号",
          placeholder: "请输入会员手机号",
          type: "input",
          key: "phone",
        },
        {
          label: "状态",
          placeholder: "请选择状态",
          type: "select",
          key: "statusList",
          option: [],
          props: {
            value: 'name',
            label: 'desc'
          }
        },
      ],
      form: {
        time:[startDate,endDate]
      },
      tableKey: false,
      exportLoading: false,
      tableThData: [
        { prop: "couponName", label: "优惠券名称", minWidth: "180", },
        { prop: "totalAmount", label: "售价", minWidth: "180", },
        { prop: "phone", label: "会员手机号", minWidth: "180", },
        { prop: "code", label: "券码", minWidth: "180", },
        { prop: "paymentOrderId", label: "交易订单号", minWidth: "180", },
        { prop: "payTime", label: "支付时间", minWidth: "280", },
        { prop: "finishTime", label: "退款时间", minWidth: "280", },
        { prop: "sourceMallName", label: "购买来源", minWidth: "280", },
        { prop: "status", label: "状态", minWidth: "180", },
        { prop: "source", label: "来源", minWidth: "120", },
      ],

    };
  },
  created () {
    this.getConfig()
  },
  methods: {
    // 获取config数据
    async getConfig() {
      const {paymentOrderStatus} = await api_getConfig('paymentOrderStatus')
      let index = this.renderData.findIndex(item => item.key == 'statusList')
      this.renderData[index].option = paymentOrderStatus || []
    },

    // 获取表格列表数据
    async getList () {
      this.loading = true
      let params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
        statusList:this.form.statusList?this.form.statusList:''
      }
      params.usedTimeFrom = this.form.time ? this.form.time[0] : ''
      params.usedTimeTo = this.form.time ? this.form.time[1] : ''
      delete params.time;
      this.$router.push({query: params})
      const data = await api_getCouponBuyRecordList(params)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },

    // 点击查看手机号
    async onLookPhone(row, index) {
      try {
        if (row.phone_show) {
          delete this.tableTrData[index].phone_show
        } else {
          const {phone} = await api_getUserPhone({id: row.userId})
          this.tableTrData[index].phone_show = aes.decrypt(phone)
        }
        this.tableKey = !this.tableKey
      } catch (error) {}
    },
    // 导出
    async onExport() {
      this.exportLoading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
        statusList:this.form.statusList?[this.form.statusList]:[]
      }
      params.usedTimeFrom = this.form.time ? this.form.time[0] : undefined
      params.usedTimeTo = this.form.time ? this.form.time[1] : undefined
      delete params.time;
      let res = await api_postCouponBuyRecordListExportV2(params)
      downFile(res)
      this.exportLoading = false
    },
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-CBR-index {
  width: 100%;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }

  .look-phone-btn {
    font-size: 10px;
    color: #3775FF;
    margin-left: 5px;
  }

  .del {
    color: #F74A4A;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .dot-success{
    background: #05c8af;
  }

  .dot-clear {
    background: #F74A4A;
  }

  .dot-ing {
    background: #3775FF;
  }

  .dot-new {
    background: #ccc;
  }
}
</style>
